import { render, staticRenderFns } from "./LoadMoreCards.vue?vue&type=template&id=8fe7dc26&"
import script from "./LoadMoreCards.vue?vue&type=script&lang=js&"
export * from "./LoadMoreCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports